
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lotterydoubleoptin",
      function () {
        return require("private-next-pages/lotterydoubleoptin.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lotterydoubleoptin"])
      });
    }
  